import React, { useRef, useEffect, useCallback } from 'react';
import { useSpacing } from '../../../api/spacing/useSpacing';
import { FormHelperText } from '../../FormHelperText';
import { StyledCheckbox } from '../Checkbox/Checkbox.styles';
import { StyledRadioButton } from '../RadioButton/RadioButton.styles';
import { StyledContainer, StyledLabel, StyledDescriptionContainer, } from './GenericOption.styles';
function preventInteraction(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
}
const noop = () => { };
export const GenericOption = React.forwardRef(function Options({ autoComplete, onBlur = noop, onChange = noop, onFocus = noop, 'data-testid': testId, checked, children: label, className, defaultChecked, disabled = false, validationMessage, hint, id, inputId, inputRef: inputRefCallback = noop, invalid = false, name, readOnly = false, required = false, type, value, ...restProps }, ref) {
    const inputRef = useRef(null);
    const hintMessageId = hint ? `${inputId}__hint-message` : undefined;
    const Input = type === 'checkbox' ? StyledCheckbox : StyledRadioButton;
    /* Prevents the case where disabled and readOnly could happen simultaneously */
    const resolvedReadOnly = disabled ? false : readOnly;
    const handleOnChange = useCallback((event) => {
        var _a;
        // Reset potentional previously set custom validity
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity('');
        onChange(event);
    }, [onChange]);
    /*
     * Setting the validity of the input node based on `props.invalid` using
     * native HTML5 Form Validtaion API
     */
    useEffect(() => {
        if (inputRef.current) {
            // Zero width whitespace is used to mark field as invalid without validation message
            inputRef.current.setCustomValidity(invalid
                ? validationMessage ||
                    inputRef.current.validationMessage ||
                    '\u200B'
                : '');
        }
    }, [invalid, validationMessage]);
    useEffect(() => {
        inputRefCallback(inputRef.current);
    }, [inputRefCallback]);
    return (React.createElement(StyledContainer, { className: className, "data-testid": testId, hasHint: Boolean(hint), id: id, outerSpacing: useSpacing(restProps), ref: ref },
        React.createElement(Input, { autoComplete: autoComplete, "aria-describedby": hintMessageId, checked: checked, defaultChecked: defaultChecked, disabled: disabled, invalid: invalid, id: inputId, name: name, onBlur: onBlur, 
            /*
             * Prevent checked state to be manipulated while readOnly since native
             * readOnly applies to the not exposed value of the input
             * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#readonly
             */
            onChange: resolvedReadOnly ? undefined : handleOnChange, onClick: resolvedReadOnly ? preventInteraction : undefined, onFocus: onFocus, readOnly: resolvedReadOnly, ref: inputRef, required: required, value: value }),
        React.createElement(StyledLabel, { htmlFor: inputId, invalid: invalid }, label),
        hint && (React.createElement(StyledDescriptionContainer, null,
            React.createElement(FormHelperText, { id: hintMessageId, variant: "hint" }, hint)))));
});
//# sourceMappingURL=GenericOption.js.map